import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as CompassIcon } from "src/images/compass.svg";
import { ReactComponent as SubscriptionIcon } from "src/images/credit-card.svg";
import { ReactComponent as EarthIcon } from "src/images/earth.svg";
import { ReactComponent as FieldIcon } from "src/images/field.svg";
import { ReactComponent as GearIcon } from "src/images/gear.svg";
import { ReactComponent as MembersIcon } from "src/images/members.svg";
import { ReactComponent as CreatorDatabaseIcon } from "src/images/menu-icons/creator-database.svg";
import { ReactComponent as PlugIcon } from "src/images/plug.svg";
import { ReactComponent as PuzzleIcon } from "src/images/puzzle.svg";
import { ReactComponent as StackIcon } from "src/images/stack.svg";
import { ReactComponent as TeamsIcon } from "src/images/teams.svg";
import { ReactComponent as TemplateIcon } from "src/images/template.svg";
import { ReactComponent as WandIcon } from "src/images/wand.svg";

import CustomImage from "src/app/components/CustomImage/CustomImage";
import { SubscriptionEntitlements } from "src/app/subscription/subscriptionUtils";
import { SettingsTab } from "../../enums";

export type TabButton = {
  label: React.ReactNode;
  value: SettingsTab;
  feature?: SubscriptionEntitlements;
};

export const getTabButtons = (
  userAvatarUrl: string | undefined,
): TabButton[] => {
  const tabButtons = [
    {
      label: (
        <>
          <GearIcon />
          <IDHFormattedMessage id="ws_general" defaultMessage="General" />
        </>
      ),
      value: SettingsTab.General,
    },
    {
      label: (
        <>
          <MembersIcon />
          <IDHFormattedMessage id="ws_members" defaultMessage="Members" />
        </>
      ),
      value: SettingsTab.Members,
    },
    {
      label: (
        <>
          <TeamsIcon />
          <IDHFormattedMessage id="ws_teams" defaultMessage="Teams" />
        </>
      ),
      value: SettingsTab.Teams,
    },
    {
      label: (
        <>
          <SubscriptionIcon />
          <IDHFormattedMessage
            id="ws_subscription"
            defaultMessage="Subscription"
          />
        </>
      ),
      value: SettingsTab.Subscription,
    },

    {
      label: (
        <>
          <GearIcon />
          <IDHFormattedMessage
            id="ws_workspace_setup"
            defaultMessage="Workspace setup"
          />
        </>
      ),
      value: SettingsTab.WorkspaceSetup,
    },
    {
      label: (
        <>
          <CompassIcon />
          <IDHFormattedMessage
            id="ws_creator_discovery"
            defaultMessage="Creator discovery"
          />
        </>
      ),
      value: SettingsTab.CreatorDiscovery,
    },
    {
      label: (
        <>
          <TemplateIcon />
          <IDHFormattedMessage
            id="ws_template_manager"
            defaultMessage="Template Manager"
          />
        </>
      ),
      value: SettingsTab.TemplateManager,
    },
    {
      label: (
        <>
          <WandIcon />
          <IDHFormattedMessage
            id="ws_automations"
            defaultMessage="Automations"
          />
        </>
      ),
      value: SettingsTab.Automations,
    },
    {
      label: (
        <>
          <PlugIcon />
          <IDHFormattedMessage id="ws_extensions" defaultMessage="Extensions" />
        </>
      ),
      value: SettingsTab.Extensions,
    },
    {
      label: (
        <>
          <CustomImage src={userAvatarUrl} />
          <IDHFormattedMessage id="ws_my_account" defaultMessage="My account" />
        </>
      ),
      value: SettingsTab.Account,
    },
    {
      label: (
        <>
          <EarthIcon />
          <IDHFormattedMessage id="ws_language" defaultMessage="Language" />
        </>
      ),
      value: SettingsTab.Language,
    },
    {
      label: (
        <>
          <FieldIcon />
          <IDHFormattedMessage
            id="ws_manage_fields"
            defaultMessage="Manage fields"
          />
        </>
      ),
      value: SettingsTab.ManageFields,
    },
    {
      label: (
        <>
          <CreatorDatabaseIcon />
          <IDHFormattedMessage
            id="ws_creator_database_extensions"
            defaultMessage="Creator database"
          />
        </>
      ),
      value: SettingsTab.CreatorDatabaseConfiguration,
    },
    {
      label: (
        <>
          <PuzzleIcon />
          <IDHFormattedMessage
            id="ws_integrations"
            defaultMessage="Integrations"
          />
        </>
      ),
      value: SettingsTab.Integrations,
    },
    {
      label: (
        <>
          <StackIcon />
          <IDHFormattedMessage
            id="ws_dictionary_manager"
            defaultMessage="Dictionary Manager"
          />
        </>
      ),
      value: SettingsTab.DictionaryManager,
      feature: SubscriptionEntitlements.DictionaryManager,
    },
  ];

  return tabButtons;
};
